import { SPOTIFY_HEADER_SIZE, SPOTIFY_HEADER_ZONES, type HeaderBox } from 'fym-shared/src/music24/spotifyHeader';

/** What a preview shows: the whole file, the desktop view (the full width) or the phone view (the middle half). */
export type HeaderView = 'file' | 'desktop' | 'phone';

/** A box in px of the file (2660 x 1140). */
export interface PxBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

const { width: W, height: H } = SPOTIFY_HEADER_SIZE;

/** A zone of `spotifyHeader.ts` in px of the file. Pure. */
export function zoneBox(zone: HeaderBox): PxBox {
  return {
    left: Math.round(zone.x0 * W),
    top: Math.round(zone.y0 * H),
    width: Math.round((zone.x1 - zone.x0) * W),
    height: Math.round((zone.y1 - zone.y0) * H),
  };
}

/**
 * The part of the file that a view shows, in px of the file: the phone view is the phone band (its
 * full height), the desktop view and the file are the whole file (the desktop guides shade the cut
 * rows). Pure.
 */
export function viewBox(view: HeaderView): PxBox {
  return view === 'phone' ? zoneBox(SPOTIFY_HEADER_ZONES.phone) : { left: 0, top: 0, width: W, height: H };
}

/** The scale from the file to a preview `width` px wide, and the preview height. Pure. */
export function previewScale(view: HeaderView, width: number): { scale: number; height: number } {
  const box = viewBox(view);
  const scale = width / box.width;
  return { scale, height: Math.round(box.height * scale) };
}

/**
 * Where Spotify draws the round photo and the name (design a1, `HeaderFrame`): bottom left of the
 * view, inside the name zone. In px of the file. Pure.
 */
export function nameOverlay(view: HeaderView): { left: number; bottom: number; avatar: number; nameSize: number } {
  const box = viewBox(view);
  return {
    left: Math.round(box.left + 0.035 * box.width),
    bottom: Math.round(0.08 * H),
    avatar: Math.round(0.24 * H),
    nameSize: Math.round(0.17 * H),
  };
}
